/**
 * Fehlerseite für den Start, wenn die App selbst nicht lädt. Ohne React und ohne `@/ui` (beide hängen am Inhaltspaket,
 * das gerade fehlt): schlichtes DOM mit denselben Klassen wie `ErrorState`.
 */
export function showBootError(root: HTMLElement): void {
  const main = document.createElement("main");
  main.className = "mx-auto flex min-h-dvh max-w-(--col-max) flex-col justify-center bg-bg px-5";
  const section = document.createElement("section");
  section.className = "flex flex-col items-center gap-3 px-6 py-10 text-center";
  section.setAttribute("role", "alert");
  const title = document.createElement("h2");
  title.className = "t-section";
  title.textContent = "Die App konnte nicht geladen werden";
  const message = document.createElement("p");
  message.className = "max-w-72 t-body text-pretty text-ink-soft";
  message.textContent =
    "Ein Teil kam nicht an, meist liegt es an der Verbindung. Prüf sie und lade die Seite neu. Dein Lernstand auf diesem Gerät bleibt erhalten.";
  const button = document.createElement("button");
  button.type = "button";
  button.className = "lt-btn lt-press mt-2";
  button.dataset.variant = "secondary";
  button.dataset.size = "md";
  const label = document.createElement("span");
  label.textContent = "Seite neu laden";
  button.append(label);
  button.addEventListener("click", () => {
    location.reload();
  });
  section.append(title, message, button);
  main.append(section);
  root.replaceChildren(main);
}
